import { orderBy } from 'lodash'

export default {
	namespaced: true,
	state: {
		scores: [],
	},
	mutations: {
		setScore(state, value) {
			if (value.session) {
				let idx = state.scores.findIndex(score => {
					return score.session == value.session
				})
				if (idx) {
					state.scores[idx] = value
				} else {
					state.scores.push(value)
				}
			}
		},
	},
	getters: {
		getHighscore: state => session => {
			if (session)
				return Math.max.apply(
					Math,
					state.scores.map(function(o) {
						return o.y && o.session !== session
					})
				)
			else
				return Math.max.apply(
					Math,
					state.scores.map(function(o) {
						return o.y
					})
				)
		},
		getHighscores: state => max => {
			if (max) return orderBy(state.scores, 'score', 'asc')
			else return orderBy(state.scores, 'score', 'asc')
		},
	},
	actions: {
		setScore({ commit }, value) {
			commit('setScore', value)
		},
	},
}
